import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const assistantAiTraceV1Schema = eventEnvelopeSchema.extend({
  userId: z.string().min(1).max(256),
  properties: z.record(z.unknown()).default({}),
});

export type AssistantAiTraceV1 = z.infer<typeof assistantAiTraceV1Schema>;

export const ASSISTANT_AI_TRACE_V1_DETAIL_TYPE = 'assistant.ai-trace.v1' as const;
